import React from 'react';
import App from './App';
import { createRoot } from "react-dom/client";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import userReducer from "./features/user";
import commonReducer from "./features/common";
import './i18n/config';    

import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';


const store = configureStore({
    reducer: {
        user: userReducer,
        common: commonReducer,
    },
});


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
document.documentElement.setAttribute("dir","rtl");



SentryReact.init({
    dsn: "https://056e1ce9e66b7e04088db2fcc4008b77@o4509282072526848.ingest.de.sentry.io/4509282073837648",
    integrations: [
        SentryReact.browserTracingIntegration(),
        SentryReact.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        })
    ],
    tracesSampleRate: 1.0, // Adjust this value in production
    replaysSessionSampleRate: 1.0, // Sample rate for session replays
    replaysOnErrorSampleRate: 1.0, // Sample rate for replays on errors
});

Sentry.init({
    dsn: "https://056e1ce9e66b7e04088db2fcc4008b77@o4509282072526848.ingest.de.sentry.io/4509282073837648",
});

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);